import React from "react";
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';
import { Link } from "@arctheme-components/elements/Link/Link";
import { Image } from "@project-stories/elements/Image/Image";

interface BlogFooterProps {
  settings: {
    settings: {
      show_share?: boolean;
      show_tags?: boolean;
    };
    article?: {
      tags?: string[];
    };
  };
}

export const BlogFooter: React.FC<BlogFooterProps> = ({ settings }) => {
  const {
    show_share = true,
    show_tags = false
  } = settings.settings;

  const article = settings.settings.article || {};
  const isMobile = useMobileBreakpoint(settings.settings.mobile_breakpoint);

  const socialLinks = [
    { name: "Link", icon: "icon-share", url: "#" },
    { name: "LinkedIn", icon: "icon-linkedin", url: "#" },
    { name: "X", icon: "icon-X1", url: "#" },
    { name: "Facebook", icon: "icon-Facebook", url: "#" }
  ];

  const tags = article.tags || [
    "Tag 1",
    "Tag 2",
    "Servicing <span class='text-green-500'>250+</span> clients",
    "<span class='text-green-500'>5%</span> Increase in conversion"
  ];

  return (
    <div className="container mx-auto mt-16 mb-20 text-center">
      {show_share && (
        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-3">Share this post</h3>
          <div className="flex justify-center gap-4">
            {socialLinks.map((link, index) => (
              <a key={index} href={link.url} className="p-2 bg-gray-100 rounded-full">
                <i className={`icon ${link.icon}`} />
              </a>
            ))}
          </div>
        </div>
      )}

      {show_tags && tags.length > 0 && (
        <div className="flex flex-wrap justify-center gap-2">
          {tags.map((tag, index) => (
            <span
              key={index}
              className="bg-black text-white text-sm px-3 py-1 rounded"
              dangerouslySetInnerHTML={{ __html: tag }}
            ></span>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogFooter;